import React from "react";
import { Box, Typography, Button, Stack, useTheme } from "@mui/material";
import { useNavigate } from "react-router-dom";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutlineRounded";

const NotFound = () => {
  const theme = useTheme();
  const navigate = useNavigate();

  const handleGoBack = () => {
    // Fall back to the dashboard when there's no history to go back to
    // (e.g. the 404 was reached by typing a URL directly).
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/dashboard");
    }
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        backgroundColor: theme.palette.background.default,
        padding: 3,
      }}
    >
      <ErrorOutlineIcon
        sx={{
          fontSize: 120,
          color: theme.palette.primary.main,
          mb: 3,
        }}
      />
      <Typography
        variant="h1"
        sx={{
          fontSize: "6rem",
          fontWeight: "bold",
          color: theme.palette.primary.main,
          mb: 1,
        }}
      >
        404
      </Typography>
      <Typography
        variant="h4"
        sx={{
          color: theme.palette.text.primary,
          mb: 2,
        }}
      >
        Page Not Found
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: theme.palette.text.secondary,
          mb: 4,
          textAlign: "center",
          maxWidth: "500px",
        }}
      >
        The page you're looking for doesn't exist or you don't have permission
        to access it.
      </Typography>
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        sx={{ width: { xs: "100%", sm: "auto" }, maxWidth: 400 }}
      >
        <Button
          variant="outlined"
          onClick={handleGoBack}
          sx={{ px: 4, py: 1.5, borderRadius: "12px" }}
        >
          Go Back
        </Button>
        <Button
          variant="contained"
          onClick={() => navigate("/dashboard")}
          sx={{ px: 4, py: 1.5, borderRadius: "12px" }}
        >
          Go to Dashboard
        </Button>
      </Stack>
    </Box>
  );
};

export default NotFound;
